"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBigIntToBN = exports.convertBNToBigInt = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
const anchor_1 = require("@coral-xyz/anchor");
const convertBNToBigInt = (obj) => {
    if (obj instanceof anchor_1.BN) {
        return BigInt(obj.toString());
    }
    if (Array.isArray(obj)) {
        return obj.map((x) => (0, exports.convertBNToBigInt)(x));
    }
    if (typeof obj !== "object" || obj === null || obj.constructor !== Object) {
        return obj;
    }
    const newObj = {};
    for (const key in obj) {
        newObj[key] =
            obj[key] instanceof anchor_1.BN
                ? BigInt(obj[key].toString())
                : (0, exports.convertBNToBigInt)(obj[key]);
    }
    return newObj;
};
exports.convertBNToBigInt = convertBNToBigInt;
const convertBigIntToBN = (obj) => {
    if (typeof obj === "bigint") {
        return new anchor_1.BN(obj.toString());
    }
    if (Array.isArray(obj)) {
        return obj.map((x) => (0, exports.convertBigIntToBN)(x));
    }
    if (typeof obj !== "object" || obj === null || obj.constructor !== Object) {
        return obj;
    }
    const newObj = {};
    for (const key in obj) {
        newObj[key] =
            typeof obj[key] === "bigint"
                ? new anchor_1.BN(obj[key].toString())
                : (0, exports.convertBigIntToBN)(obj[key]);
    }
    return newObj;
};
exports.convertBigIntToBN = convertBigIntToBN;
